import { render } from "./RacingLeaderboard.vue?vue&type=template&id=66b9d9f4&ts=true"
import script from "./RacingLeaderboard.vue?vue&type=script&lang=ts"
export * from "./RacingLeaderboard.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__